import { Image } from '@/atoms/Image'
import { useTranslate } from '@/utils/translate/translate-client'
import { HomesteadEyebrowSM, HomesteadParagraphSM, HomesteadTitleLG } from '../components/Typography'

export const prizeItemsList = [
  {
    image: '/v1727735733/Homestead/prizes/homestead-boxhouse-01.webp',
    alt: 'Box House',
    title: 'Box House 500 Sq. Ft. Tiny House',
    value: '$139,000',
  },
  {
    image: '/v1727735730/Homestead/prizes/DSC06697.webp',
    alt: '',
    title: 'Polaris Xpedition OHV Customized by the Diesel Brothers',
    value: '$75,000',
  },
  {
    image: '/v1727735729/Homestead/prizes/bitcoin-01.webp',
    alt: '',
    title: 'One BitCoin (BTC)',
    value: '$65,000',
  },
  {
    image: '/v1727735723/Homestead/prizes/AngelStudio_09172413178.webp',
    alt: '',
    title: 'Bakcou Full Suspension eBike',
    value: '$5,200',
  },
  {
    image: '/v1727735721/Homestead/prizes/AngelStudio_09172413077.webp',
    alt: '',
    title: 'NutriStore Freeze Dried 6-Month Food Supply',
    value: '$4,438',
  },
  {
    image: '/v1727735740/Homestead/prizes/sungrow-greenhouse-sungrow-20.webp',
    alt: '',
    title: 'Planta Greenhouses - Sungrow 20',
    value: '$3,800',
  },
  {
    image: '/v1727735737/Homestead/prizes/IMG_8556.webp',
    alt: '',
    title: 'PlayXTAC Four Person Tactical Laser Airsoft Kit',
    value: '$2,304',
  },
  {
    image: '/v1727735735/Homestead/prizes/homestead-rockwell-water-01.webp',
    alt: '',
    title: 'Two 250-Gallon QuakeTank Water Storage Tanks',
    value: '$1,800',
  },
  {
    image: '/v1727735725/Homestead/prizes/AngelStudio_09172413239.webp',
    alt: '',
    title: 'Lion Energy Portable Solar Power Unit (Lion Safari)',
    value: '$1,500',
  },
  {
    image: '/v1727735725/Homestead/prizes/AngelStudio_09172413261.webp',
    alt: '',
    title: 'Knafs Lulu Knife + Gear Bundle',
    value: '$750',
  },
  {
    image: '/v1727735722/Homestead/prizes/AngelStudio_09172413112.webp',
    alt: '',
    title: 'NutriMill - Mill & Mixer',
    value: '$749',
  },
  {
    image: '/v1727735726/Homestead/prizes/AngelStudio_09172413276.webp',
    alt: '',
    title: 'Thirsty Earth: CottaCup Automatic Olla Watering System & Three Planter Boxes',
    value: '$700',
  },
  {
    image: '/v1727735728/Homestead/prizes/AngelStudio_09172413351.webp',
    alt: '',
    title: 'Three Pair of GATORZ Eyewear',
    value: '$650',
  },
  {
    image: '/v1727735732/Homestead/prizes/DSC07534.webp',
    alt: '',
    title: 'Oberwerk 20x65 ED Binocular on Oberwerk 4000 Tripod',
    value: '$600',
  },
  {
    image: '/v1727735723/Homestead/prizes/AngelStudio_09172413192.webp',
    alt: '',
    title: 'Uncharted Supply Co - SEVENTY2 Pro Survival System',
    value: '$589',
  },
  {
    image: '/v1727735722/Homestead/prizes/AngelStudio_09172413091.webp',
    alt: '',
    title: '100 Utah GoldBacks - Pure Gold',
    value: '$542',
  },
  {
    image: '/v1729197021/IMG_8555.webp',
    alt: '',
    title: 'Rockwell Time - Ruck Backpack, Sunglasses, Apparel',
    value: '$500',
  },
  {
    image: '/v1729193204/plusefire-flamethrower-01.webp',
    alt: '',
    title: 'Exothermic Technologies PulseFire Long Range Torch',
    value: '$499',
  },
  {
    image: '/v1727735731/Homestead/prizes/DSC07533.webp',
    alt: '',
    title: 'ISOtunes Hearing Protection - Four Advance BT Earbuds + Two Defy Slim Basic Earmuffs',
    value: '$460',
  },
  {
    image: '/v1727735729/Homestead/prizes/AngelStudio_09172413393.webp',
    alt: '',
    title: 'PROTEK Watches USMC Dive Watch',
    value: '$450',
  },
  {
    image: '/v1727735727/Homestead/prizes/AngelStudio_09172413308.webp',
    alt: '',
    title: 'MIRA Safety EvakPak',
    value: '$370',
  },
  {
    image: '/v1727735733/Homestead/prizes/homestead-grip6-gear-01.webp',
    alt: '',
    title: 'GRIP6 - Belts, Wallets, and Socks',
    value: '$350',
  },
  {
    image: '/v1727735727/Homestead/prizes/AngelStudio_09172413344.webp',
    alt: '',
    title: 'Fix It Sticks - All-in-One Toolkit',
    value: '$292',
  },
  {
    image: '/v1727735735/Homestead/prizes/IMG_8483.webp',
    alt: '',
    title: 'MyMedic MyFAK Pro Full Medical Kit',
    value: '$227',
  },
  {
    image: '/v1727735724/Homestead/prizes/AngelStudio_09172413223.webp',
    alt: '',
    title: 'Black Beard Fire - Ultimate Fire Kit',
    value: '$225',
  },
  {
    image: '/v1727735738/Homestead/prizes/olli-apparel-img-01.webp',
    alt: '',
    title: 'Olli Bottoms of Your Choice, Olli Top of Your Choice, and Olli Headband',
    value: '$137',
  },
  {
    image: '/v1727735738/Homestead/prizes/katio-radio-02.webp',
    alt: '',
    title: 'Kaito Voyager Pro KA600',
    value: '$90',
  },
  {
    image: '/v1727735722/Homestead/prizes/AngelStudio_09172413103.webp',
    alt: '',
    title: 'Black Rifle Coffee Gift Pack',
    value: '$70',
  },
]

export const PrizeItemsTab = () => {
  const { t } = useTranslate('tickets')

  return (
    <div className="px-4">
      <div className="my-10 md:mt-16">
        <HomesteadTitleLG>{t('grandPrizeItems', 'Grand Prize Items')}</HomesteadTitleLG>
        <HomesteadParagraphSM className="mt-3">
          {t(
            'grandPrizeItemsDescription',
            'Below is the collection of the Homestead giveaway items included in this giveaway.',
          )}
        </HomesteadParagraphSM>
      </div>
      <div className="mb-10 grid gap-6 lg:grid-cols-2">
        {prizeItemsList.map((prizeItem, index) => (
          <PrizeItem
            key={index}
            image={prizeItem.image}
            alt={prizeItem.alt}
            title={prizeItem.title}
            value={prizeItem.value}
          />
        ))}
      </div>
    </div>
  )
}

interface PrizeItemProps {
  image: string
  alt: string
  title: string
  value: string
}

const PrizeItem = ({ image, alt, title, value }: PrizeItemProps) => {
  const { t } = useTranslate('tickets')

  return (
    <div className="flex flex-col py-4">
      <div className="aspect-h-9 aspect-w-16 relative overflow-hidden rounded-lg">
        <Image
          src={image}
          alt={alt}
          fill
          className="object-cover"
          sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
        />
      </div>
      <div className="flex justify-between gap-4 pb-1 pt-4">
        <div className="w-2/3">
          <HomesteadEyebrowSM className="font-semibold" color="homestead-blue">
            {t('item', 'item')}
          </HomesteadEyebrowSM>
          <HomesteadParagraphSM color="homestead-primary-blue">{title}</HomesteadParagraphSM>
        </div>
        <div>
          <HomesteadEyebrowSM className="font-semibold" color="homestead-blue">
            {t('value', 'value')}
          </HomesteadEyebrowSM>
          <HomesteadParagraphSM className="text-gray-500" color="homestead-primary-blue">
            {value}
          </HomesteadParagraphSM>
        </div>
      </div>
    </div>
  )
}
